export type ContactRequest = {
  name: string; email: string; business: string; service: string; message: string;
  utmSource?: string | null; utmMedium?: string | null; utmCampaign?: string | null;
};
export async function submitContact(payload: ContactRequest, send: typeof fetch = fetch): Promise<void> {
  const response = await send('/api/contact', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload), signal: AbortSignal.timeout(12000),
  });
  if (!response.ok || (await response.json())?.ok !== true) throw new Error('Message delivery not confirmed');
}
